/* globals Backbone, _ */
const { Collection } = Backbone;

import Model from '../models/base';

const { extend, filter } = _;

export default Collection.extend( {
	model: Model,

	_prepareModel: function() {
		var result = Collection.prototype._prepareModel.apply( this, arguments );

		if ( result ) {
			extend( result.libraries, this.libraries );
		}

		return result;
	},

	preinitialize: function( models, options = {} ) {
		this.libraries = extend( {}, options.libraries || {} );
	},

	get: function( id ) {
		if ( id instanceof Array ) {
			const results = id.map( _id => this.get( _id ) );
			return filter( results, value => Boolean( value ) );
		}

		return Collection.prototype.get.call( this, id );
	},

	callEach: function( method ) {
		var args = Array.prototype.slice.call( arguments, 1 );

		if ( typeof method !== 'function' ) {
			method = this.model.prototype[ method ];
		}

		return this.each( function( child ) {
			method.apply( child, args );
		} );
	},

	filterSelf: function( predicate ) {
		var toRemove = this.reject( predicate );

		return this.remove( toRemove );
	},

	sort: function( options = {} ) {
		Collection.prototype.sort.call( this, { silent: true } );
		if ( this.sortOrder === 'desc' ) {
			this.models.reverse();
		}

		if ( ! options.silent ) {
			this.trigger( 'sort', this, options );
		}

		return this;
	},

	dump: function( id ) {
		var data = [];

		if ( typeof id !== 'undefined' ) {
			const model = this.get( id );
			if ( model ) {
				return model.dump();
			}

			return null;
		}

		this.each( model => {
			data.push( model.dump() );
		} );

		return data;
	},
} );
